import React, { FC } from "react";
import { useForm } from "react-hook-form";
import Input from "../../../shared/Input/Input";
import Textarea from "../../../shared/Textarea/Textarea";
import ButtonSecondary from "../../../shared/Button/ButtonSecondary";
import ButtonPrimary from "../../../shared/Button/ButtonPrimary";
import Label from "../../../components/Label/Label";

export const FAQForm: FC<{
  onSubmit: (data: { question: string; answer: string }) => void;
  onCancel: () => void;
  defaultValues?: { question: string; answer: string };
  isEditing?: boolean;
}> = ({ onSubmit, onCancel, defaultValues = { question: "", answer: "" }, isEditing = false }) => {
  const { register, handleSubmit, formState: { errors } } = useForm({
    defaultValues
  });

  return (
    <>
      <div className={"mt-5"}>
        <Label className="mb-3">Question</Label>
        <Input
          {...register("question", { required: "Question is required" })}
          placeholder="Enter the question"
          className="w-full"
        />
        {errors.question && (
          <span className="text-red-500 text-sm">{errors.question.message}</span>
        )}
      </div>

      <div className={"mt-5"}>
        <Label className="mb-3">Answer</Label>
        <Textarea
          {...register("answer", { required: "Answer is required" })}
          placeholder="Enter the answer"
          className="w-full h-32"
        />
        {errors.answer && (
          <span className="text-red-500 text-sm">{errors.answer.message}</span>
        )}
      </div>

      <div className="flex justify-end space-x-3 mt-5 p-5">
        <ButtonSecondary onClick={onCancel}>Cancel</ButtonSecondary>
        <ButtonPrimary onClick={handleSubmit(onSubmit)}>{isEditing ? "Update" : "Add"}</ButtonPrimary>
      </div>
    </>
  );
};
